import { HttpClient } from '@angular/common/http'
import { inject, Injectable, signal } from '@angular/core'
import { Observable, of } from 'rxjs'
import { catchError, map, tap } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { getCurrentUserId } from '../utils/current-user'
import {
  KANBAN_PERMISSION_NAMESPACE,
  KANBAN_PERMISSION_OBJECT,
  KanbanRelation
} from '../models/kanban-permission.model'

const CHECKED_RELATIONS = [
  KanbanRelation.BOARD_LISTER,
  KanbanRelation.BOARD_READER,
  KanbanRelation.BOARD_WRITER,
  KanbanRelation.CARD_WRITER
] as const

@Injectable({
  providedIn: 'root'
})
export class KanbanPermissionService {
  private http = inject(HttpClient)

  canListBoard = signal(false)
  canReadBoard = signal(false)
  canWriteBoard = signal(false)
  canWriteCard = signal(false)

  checkAccess(): Observable<boolean> {
    const subjectId = getCurrentUserId()
    if (!subjectId) {
      this.canListBoard.set(false)
      this.canReadBoard.set(false)
      this.canWriteBoard.set(false)
      this.canWriteCard.set(false)
      return of(false)
    }

    const tuples = CHECKED_RELATIONS.map(relation => ({
      namespace: KANBAN_PERMISSION_NAMESPACE,
      object: KANBAN_PERMISSION_OBJECT,
      relation,
      subjectId
    }))

    return this.http
      .post<{ allowed: boolean }[]>(
        `${environment.permissionsApiUrl}/permissions/v1/relations/batch/check`,
        { tuples }
      )
      .pipe(
        map(results => CHECKED_RELATIONS.map((_, index) => results[index]?.allowed ?? false)),
        catchError(() => of(CHECKED_RELATIONS.map(() => false))),
        tap(([canList, canRead, canWriteBoard, canWriteCard]) => {
          this.canListBoard.set(canList)
          this.canReadBoard.set(canRead)
          this.canWriteBoard.set(canWriteBoard)
          this.canWriteCard.set(canWriteCard)
        }),
        map(([, canRead]) => canRead)
      )
  }
}
